import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import styles from "styles/component/ListTableContent.module.scss";
import styles1 from "styles/component/PopOver.module.scss";
import popperStyles from "styles/component/Popper.module.scss";
import {
  Box,
  Button,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import asset from "json/assets";
import {
  checkAndUnionArrays,
  convertObjectToArray,
  convertToLabelName,
  getModalProperties,
  getNumberFromLabel,
} from "services/utils";
import { useDispatch } from "react-redux";
import {
  selectZone,
  setEditableArea,
  setMapData,
  setVisibleArea,
  setVisibleZoneList,
} from "redux/MapSlice";
import {
  useAddedShapedStatus,
  useEditableArea,
  useMapShapeData,
  useVisibleAreas,
  useVisibleZoneList,
} from "hooks/MapDetails";
import {zoneTypeList } from "json/constants";
// import eventEmitter from "services/event.emitter";
// import events from "json/events";
import ModalWrapper from "layout/ModalWrapper/ModalWrapper";
import NoificationModal from "pages/ModalPage/NoificationModal";
import { useRefHook } from "hooks/useRefHook";
// const ButtonMemo=memo(({mod2})=>{
//   const [bg,setBg]=useState('')

//   useEffect(()=>{
//     setBg(bg)
//   },[mod2])
//   return <Button
//   disabled
//   style={{
//     backgroundColor: `${mod2?.includes('#')?mod2:"red"}`,
//   }}
//  >{mod2}
// </Button>
// })

export default function ListTableContent(props) {
  const dispatch = useDispatch();
  const {
    // isTableStylesTwo,
    contentData,
    cancelEdit = () => {},
  } = props;
  const invisibleZoneList = useVisibleZoneList();
  const visibleAreasList = useVisibleAreas();
  const modalProperties = getModalProperties();

  const editableArea = useEditableArea();
  const addedShapeStatus = useAddedShapedStatus();
  const shapeData = useMapShapeData();
  //default selected zone
  const [openConfModal, setOpenConfModal] = useState(false);
  const [openDelAllConfModal, setOpenDelAllConfModal] = useState(false);


  const [selectedZone, setSelectedZone] = useState(
    contentData ? Object.keys(contentData)[0] : "NA"
  );
  const [showableData, setShowableData] = useState();

  const singleType = Object.keys(contentData)?.length === 1 ? true : false;
  const [maxModFieldCount, setMaxModFieldCount] = useState(0);

  const handleAllDelClose = () => {
    setOpenDelAllConfModal(false);
  };
  const handleClose = () => {
    setOpenConfModal(false);
  };
  const handleChange = (event) => {
    setSelectedZone(event.target.value);
    setMaxModFieldCount(0);
  };
  // const showableDataRef = useRefHook(showableData);
  const showableDataRef = useRefHook();

  const fillData = () => {
      if (selectedZone !== "NA") {
        let item = convertObjectToArray(contentData[`${selectedZone}`]);
        let updatedZoneDetails = convertToTableData(item);
        // 
        if(!showableDataRef.current ||showableDataRef.current.zone!==selectedZone ){
          showableDataRef.current={zone:selectedZone,data:updatedZoneDetails}
        }
        setShowableData(updatedZoneDetails);
        let visibleAreas = [];
        // updatedZoneDetails?.map((item, index) => {
        //   visibleAreas.push(item?.label);
        // });
        updatedZoneDetails?.forEach((item, index) => {
          visibleAreas.push(item?.label);
        });

        let updatedVisibleAreaList = [...visibleAreasList];
        const labels = Object.values(shapeData)
          .flatMap((item) => item.map((subItem) => subItem.label))
          .filter((label) => label !== undefined);

        const result = checkAndUnionArrays(updatedVisibleAreaList, labels);

        if (!result.isEqual) {
          dispatch(setVisibleArea(result.unionArray));
        }

        dispatch(
          selectZone({
            zone: selectedZone,
            details: updatedZoneDetails,
            type:
              updatedZoneDetails[0]?.type || zoneTypeList[`${selectedZone}`],
          })
        );

        // custom save
      }
  };
  useEffect(() => {
    fillData();
 
  }, [selectedZone, contentData]);

  useEffect(() => { // auto scroll to newly added element 
    if (showableData?.length && showableData?.length>1) { 
      const oldShapeInt=showableDataRef.current?.data?.length!==0? getNumberFromLabel(showableDataRef.current?.data?.at(-1)?.label):0;
      const newShapeInt=getNumberFromLabel(showableData?.at(-1)?.label);
      if(showableDataRef.current?.zone===selectedZone && 
        // showableDataRef.current?.data?.length<showableData?.length
        oldShapeInt<newShapeInt
        )
      {
        scrollToRef(showableData.at(-1)?.label)
        showableDataRef.current={zone:selectedZone,data:showableData}
      }
    }
  }, [showableData,showableDataRef.current])
 

  // const saveElementChanges = () => {
  //   if (addedShapeStatus === "drawing") {
  //     // setErrorMsg("Please finish drawing before saving.");
  //     return;
  //   }
  //   if (addedShapeStatus === "completed") {
  //     eventEmitter.emit(events.addNewShape);
  //   } else if (editableArea) {
  //     eventEmitter.emit(events.savePolygon);
  //   }
  // };

  const convertToTableData = useCallback(
    (shapes) => {
      let tableData = [];
      shapes.map((item, index) => {
        let count = 0;
        let modFields = [];
        Object.keys(item).forEach((keyName) => {
          if (keyName.startsWith("mod")) {
            // if((item[`${keyName}`])){
            //   count = count + 1;
            // }
            if (
              (keyName === "mod1" && item[`${keyName}`]) ||
              (keyName === "mod2" &&
                item[`${keyName}`] &&
                item[`${keyName}`]?.includes("#"))
            ) {
              count = count + 1;
            }
 
          }

          // if (
          //   item[`${keyName}`] &&
          // keyName.startsWith("mod") && item[`${keyName}`]?.includes("#") ) {
          //   // if (keyName !== "mod1") {
          //     count = count + 1;
          //     modFields.push(keyName);
          //   // }
          // }
        });
        if (count > maxModFieldCount) {
          setMaxModFieldCount(count);
        }
        let obj2 = {
          ...item,
          modfieldCount: count,
          eye: `${asset.eye}`,
          close: `${asset.close}`,
          activeStatus: true,
          modFields: modFields,
        };

        tableData.push(obj2);
      });
      return tableData;
    },
    [selectedZone]
  );

  let AllLanding = {
    name: "All Landing Areas",
    icon1: "",
    icon2: "",
    iconYlw: false,
    eye: `${asset.eye}`,
    activeStatus: true,
    close: `${asset.close}`,
  };

 
 

  const getActiveViewIcon = (label) => {
    return (
      visibleAreasList?.includes(label) &&
      !invisibleZoneList?.includes(selectedZone)
    );
  };
  const isEditEnabled = (label) => {
    return editableArea === label;
  };
  const toggleActivePolygonView = (label) => {
    let temp = [...visibleAreasList];
    if (visibleAreasList?.includes(label)) {
      // toggle off
      let index = temp.indexOf(label);
      temp.splice(index, 1);
      dispatch(setVisibleArea(temp));
    } else {
      //toggle on
      temp.push(label);
      dispatch(setVisibleArea(temp));
    }
  };

  const toggleAllActivePolygonView = useCallback(() => {
    let item = convertObjectToArray(contentData[`${selectedZone}`]);
    let updatedZoneDetails = convertToTableData(item);

    let temp = [...invisibleZoneList];
    if (invisibleZoneList?.includes(selectedZone)) {
      // toggle off
      let index = temp.indexOf(selectedZone);
      temp.splice(index, 1);
      dispatch(setVisibleZoneList(temp));

      //resetting invidiually turned off elements to visible state. ~ needs code refining
      let elementList = [];
      elementList.push(...updatedZoneDetails?.map((s) => s.label));
      dispatch(setVisibleArea(elementList));
    } else {
      //toggle on
      temp.push(selectedZone);
      dispatch(setVisibleZoneList(temp));
    }
  }, [selectedZone, invisibleZoneList, contentData]);

  const toggleEditMode = (data) => {
    if (addedShapeStatus !== "idle") {
      // user has drawing mode active
      return;
    }

    if (isEditEnabled(data?.label)) {
      dispatch(setEditableArea(""));
      cancelEdit();
    } else {
      if (!editableArea) {
        dispatch(setEditableArea(data?.label));
      }
    }
  };

  const clearAllElements = () => {
    let temp_shapeData = { ...shapeData };

    const labels = temp_shapeData[`${selectedZone}`]
      ?.flatMap((item, index) => item.label)
      .filter((label) => label !== undefined);

    let updatedList = [];
    visibleAreasList?.forEach((item, index) => {
      if (!labels?.includes(item)) {
        updatedList.push(item);
      }
    });
    dispatch(setVisibleArea(updatedList)); // clearing from view

    temp_shapeData[`${selectedZone}`] = [];
    let reduxData = { shapes: temp_shapeData };

    dispatch(setMapData(reduxData)); //clearing from dataset
  };

  const [selectedShape, setSelectedShape] = useState(null);
  const getDeleteConfirmation = (data) => {
    setOpenConfModal(true);
  };

  const getDeleteAllConfirmation = (data) => {
    setOpenDelAllConfModal(true);
  };
  const clearSelectedElements = useCallback(
    (data) => {
 

      // return;

      let temp_shapeData = { ...shapeData };
      let currentZone = [...temp_shapeData[`${selectedZone}`]];
      let pos = temp_shapeData[`${selectedZone}`]?.findIndex(
        (s) => s.label === data?.label
      );
      currentZone?.splice(pos, 1);
      temp_shapeData[`${selectedZone}`] = currentZone;
      let reduxData = { shapes: temp_shapeData };
      let temp = [...visibleAreasList];
      if (visibleAreasList?.includes(data?.label)) {
        // toggle off
        let index = temp.indexOf(data?.label);
        temp.splice(index, 1);
        dispatch(setVisibleArea(temp));
      }

      dispatch(setMapData(reduxData));
    },
    [selectedShape]
  );

 
  const ScrollableClient = useRef();

  const confirmationAction=()=>{
    handleClose();
    if(selectedShape){
      clearSelectedElements(selectedShape);
    }
    // else{
    //   clearAllElements()
    // }
  }
  const confirmationDelAllAction=()=>{
    handleAllDelClose();
      clearAllElements() 
  }
  const scrollToRef = (id) => {

    if (typeof (id)==='string') {
        const _doc = document.getElementById(id);
        if (_doc !== null) {
            _doc?.scrollIntoView({behavior:'smooth'});
        }
      }
};

  return (
    <>
      <div
        className={`${
          !singleType ? "" : `${styles.table_select}${styles.table_blank}`
        }`}
      >
        {!singleType ? (
          <Box
            className={`${popperStyles.popover_body_new} ${popperStyles.popover_body_zoneList}`}
          >
            <FormControl>
              <RadioGroup value={selectedZone} onChange={handleChange}>
                {contentData &&
                  Object.keys(contentData).map((dataItem) => {
                    return (
                      <FormControlLabel
                        key={dataItem}
                        className={
                          contentData[dataItem]?.length > 0
                            ? `${popperStyles.green_border}`
                            : ""
                        }
                        value={dataItem}
                        control={
                          <Radio checked={dataItem === selectedZone} />
                        }
                        label={convertToLabelName(dataItem)}
                        disabled={
                          editableArea || addedShapeStatus !== "idle"
                            ? true
                            : false
                        }
                      />
                    );
                  })}
              </RadioGroup>
            </FormControl>
          </Box>
        ) : (
          ""
        )}
      </div>
      <div className={styles.table_btm} ref={ScrollableClient} id="listContainer">
        {/* <table className={isTableStylesTwo  ?`${styles.table_two}`:""}> */}
        {contentData[`${selectedZone}`]?.length === 0 ? (
          <div className={styles1.list_icon_para}>
            <p className={styles.no_marker_text}>{`No ${convertToLabelName(selectedZone)} Mapped`}</p>
          </div>
        ) : ( 
          <table className={""} id={"list_table"}>
            <thead>
              <tr>
                <th>{ 
                (convertToLabelName(selectedZone) ==='Facility Marker' ||convertToLabelName(selectedZone) ==='Perimeter') 
                ? `All ${convertToLabelName(selectedZone)}s`:
                `All ${convertToLabelName(selectedZone)}`
                }</th>
                {maxModFieldCount > 0 &&
                  Array.apply(null, Array(maxModFieldCount)).map(
                    (item, index) => <th key={item}></th>
                  )}
                <th>
                  <Box className={styles.color_mod_box}>
                    <Button
                      className={`${
                        !invisibleZoneList?.includes(selectedZone) &&
                        !editableArea
                          ? `${styles.green}`
                          : `${styles.grey}`
                      }`}
                      disabled={editableArea}
                      onClick={toggleAllActivePolygonView}
                    >
                      <img src={AllLanding?.eye} alt="" />
                    </Button>
                  </Box>
                </th>
                <th>
                  <Box className={styles.color_mod_box}>
                    <Button
                     disabled={editableArea}
                      className={`${styles.green}`}
                      onClick={getDeleteAllConfirmation}
                    >
                      <img src={AllLanding?.close} alt="" />
                    </Button>
                  </Box>
                </th>
              </tr>
            </thead>
            <tbody>
              {/* {isPending ? (
                <div className={styles1.list_icon_para}>
                  <p className={styles.no_marker_text}>Loading..</p>
                </div>
              ) : (
                <> */}
                  {/* <InfiniteScroll
            
          dataLength={selectedZoneDetails?.length}
          next={fetchMoreData}
          hasMore={true}
          loader={<h4>Loading...</h4>}
          height={400}
          endMessage={
            <p style={{ textAlign: "center" }}>
              <b>Yay! You have seen it all</b>
            </p>
          }
          > */}
                  {
                    // selectedZoneDetails.length > 0 &&
                    showableData?.map((data, index) => {
                      return (
                        <tr key={index} id={data?.label}>
                          <td
                            style={{
                              cursor: "pointer",
                              outline:
                                editableArea === data?.label
                                  ? "1px dashed #133E84"
                                  : "",
                            }}
                            // onClick={()=>{toggleEditMode(data)}}
                            onDoubleClick={() => {
                              visibleAreasList?.includes(data?.label) &&
                                toggleEditMode(data);
                            }}

                            // className={noProp===true?`${styles.defaultzone_save_btn}` :""}
                          >
                            <Stack
                              direction={"row"}
                              alignItems={"center"}
                              flexWrap={"wrap"}
                              justifyContent={"space-between"}
                            >
                              {data?.label}
                              {/* {noProp === true &&
                              data?.label === editableArea ? (
                                <Button
                                  className={styles.defaultzone_save_btn}
                                  onClick={saveElementChanges}
                                > 
                                  <img src={asset.editIcon} alt="Save" />
                                </Button>
                              ) : (
                                ""
                              )} */}
                            </Stack>
                          </td>
                          {data?.mod1 && (
                            <td>
                              <Box className={styles.color_mod_box}>
                                <Button
                                  disabled
                                  className={
                                    data?.icon1 === "" && `${styles.empty_btn}`
                                  }
                                >
                                  {data?.mod1 ? data?.mod1[0] : ""}
                                </Button>
                              </Box>
                            </td>
                          )}

                          {data?.mod2 && data?.mod2?.includes("#") && (
                            <td>
                              <Box className={styles.color_mod_box}>
                                <Button
                                  className={styles.gradient_btn}
                                  disabled
                                  style={{
                                    backgroundColor: `${data?.mod2}`,
                                  }}
                                ></Button>
                              </Box>
                            </td>
                          )}

                          <td>
                            <Box className={styles.color_mod_box}>
                              <Button
                                id={index}
                                className={
                                  getActiveViewIcon(data?.label) &&
                                  !editableArea
                                    ? `${styles.green}`
                                    : `${styles.grey}`
                                }
                                disabled={editableArea}
                                onClick={() => {
                                  toggleActivePolygonView(data?.label);
                                }}
                              >
                                <img src={data?.eye} alt="" />
                              </Button>
                            </Box>
                          </td>
                          <td>
                            <Box className={styles.color_mod_box}>
                              <Button
                               disabled={editableArea}
                                onClick={() => {
                                  setSelectedShape(data);
                                  getDeleteConfirmation();
                                }}
                              >
                                <img src={data?.close} alt="" />
                              </Button>
                            </Box>
                          </td>
                        </tr>
                      );
                    })
                  }

                  {/* </InfiniteScroll> */}
                {/* </>
              )} */}

              {/* )} */}
            </tbody>
          </table>
        )}
      </div>

      <ModalWrapper
        open={openConfModal}
        onClose={handleClose}
        handleClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.error.icon}
          title= { `<span style='font-size:14px'>Are you sure you want to delete 
             <br/>${selectedShape?.label} from ${convertToLabelName(selectedZone)}?</span>`
            }
          // content="Any unsaved data will be discarded."
          rejCallBack={handleClose}
          affrCallBack={confirmationAction}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>

      <ModalWrapper
        open={openDelAllConfModal}
        onClose={handleAllDelClose}
        handleClose={handleAllDelClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <NoificationModal
          label="Warning"
          backgroundColor={modalProperties.info.backgroundColor}
          image={modalProperties.error.icon}
          title= { `<span style='font-size:14px'>Are you sure you want to delete 
             <br/>all data from ${convertToLabelName(selectedZone)}?</span>`
            }
          // content="Any unsaved data will be discarded."
          rejCallBack={handleAllDelClose}
          affrCallBack={confirmationDelAllAction}
          affrBtnTxt={"Continue"}
          rejBtnTxt={"Cancel"}
        />
      </ModalWrapper>
    </>
  );
}
